import React, { Fragment, useState, useEffect } from "react";
import logo from "../../../assets/images/ambu-medik.png";
import UserPanel from "./userPanel";
import { MENUITEMS } from "../../../components/common/sidebar-component/menu";
import { Link, useLocation } from "react-router-dom";
import styles from "./sidebar.module.css";
import { useTranslation } from "react-i18next";

const Sidebar = (props) => {
  const { pathname } = useLocation();
  const [menuItems, setMenuItems] = useState(MENUITEMS);
  const { t } = useTranslation();

  useEffect(() => {
    const activateMenuItems = (items, path) => {
      return items.map((item) => {
        const isActive =
          item.path === path ||
          path.includes(item.path) ||
          (item.children &&
            item.children.some(
              (child) =>
                child.path === path ||
                child.children?.some((subChild) => subChild.path === path)
            ));

        return {
          ...item,
          active: isActive,
          children: item.children ? activateMenuItems(item.children, path) : [],
        };
      });
    };

    const updatedMenu = activateMenuItems(MENUITEMS, pathname);
    setMenuItems(updatedMenu);
  }, [pathname]);

  const toggletNavActive = (item) => {
    const updateMenuItems = (items, targetItem, activePath) => {
      return items.map((menuItem) => {
        if (menuItem === targetItem) {
          if (menuItem.children) {
            // Toggle open/close for items with children
            menuItem.active = !menuItem.active;
          } else {
            // For items without children, just mark as active without toggling open/close
            menuItem.active = true;
          }
        } else {
          menuItem.active = false;
          if (menuItem.children) {
            menuItem.children = updateMenuItems(
              menuItem.children,
              targetItem,
              activePath
            );
            // Set the parent active if any of its children are active
            if (menuItem.children.some((child) => child.active)) {
              menuItem.active = true;
            }
          }
        }

        // Ensure the menu item where the active path resides stays open
        if (menuItem.path === activePath) {
          menuItem.active = true;
        }

        return menuItem;
      });
    };

    // Get the active path from the current location
    const activePath = pathname; // Assuming pathname is available from useLocation

    setMenuItems(updateMenuItems(menuItems, item, activePath));
  };

  return (
    <Fragment>
      <div className="page-sidebar">
        <div className="main-header-left d-none d-lg-block">
          <div className="logo-wrapper compactLogo">
            <Link
              to="/dashboard"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div></div>
              <img
                className="blur-up lazyloaded"
                style={{ width: "70%", height: "auto" }}
                src={logo}
                alt="logo"
              />
            </Link>
          </div>
        </div>
        <div className="sidebar custom-scrollbar">
          <UserPanel />
          <ul className="sidebar-menu" id="myDIV">
            {menuItems.map((menuItem, i) => (
              <li
                key={i}
                className={`${
                  menuItem.active ||
                  (menuItem.children &&
                    menuItem.children.some((child) => child.active))
                    ? "active"
                    : ""
                }`}
              >
                {menuItem.sidebartitle ? (
                  <div className="sidebar-title">{menuItem.sidebartitle}</div>
                ) : null}
                {menuItem.type === "sub" && menuItem.children ? (
                  <Link
                    className={`sidebar-header ${styles.link}`}
                    to="#"
                    style={{ color: "#222222" }}
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    <menuItem.icon />
                    <span className={styles.text}>{t(menuItem.title)}</span>
                    <i
                      className={`fa fa-angle-right pull-right ${
                        menuItem.active ? "open" : ""
                      }`}
                    ></i>
                  </Link>
                ) : null}
                {menuItem.type === "link" ? (
                  <Link
                    to={`${menuItem.path}`}
                    className={`sidebar-header ${styles.link}`}
                    style={{ color: menuItem.active ? "#4466f2" : "#222222" }}
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    <menuItem.icon />
                    <span className={styles.text}>{t(menuItem.title)}</span>
                    {menuItem.children && menuItem.children.length > 0 ? (
                      <i
                        className={`fa fa-angle-right pull-right ${
                          menuItem.active ? "open" : ""
                        }`}
                      ></i>
                    ) : null}
                  </Link>
                ) : null}
                {menuItem.children ? (
                  <ul
                    className={`sidebar-submenu ${
                      menuItem.active ? "menu-open" : ""
                    }`}
                    style={
                      menuItem.active
                        ? { opacity: 1, transition: "opacity 500ms ease-in" }
                        : {}
                    }
                  >
                    {menuItem.children.map((childrenItem, index) => (
                      <li
                        key={index}
                        className={`${
                          childrenItem.active ||
                          (childrenItem.children &&
                            childrenItem.children.some(
                              (subItem) => subItem.active
                            ))
                            ? "active"
                            : ""
                        }`}
                      >
                        {childrenItem.type === "sub" &&
                        childrenItem.children ? (
                          <Link onClick={() => toggletNavActive(childrenItem)}>
                            <i className="fa fa-circle"></i>
                            <span className={styles.text}>
                              {t(childrenItem.title)}
                            </span>
                            <i
                              className={`fa fa-angle-right pull-right ${
                                childrenItem.active ? "open" : ""
                              }`}
                            ></i>
                          </Link>
                        ) : null}

                        {childrenItem.type === "link" ? (
                          <Link
                            to={`${childrenItem.path}`}
                            className={styles.link}
                            style={{
                              color: childrenItem.active
                                ? "#4466f2"
                                : "#222222",
                            }}
                            onClick={() => toggletNavActive(childrenItem)}
                          >
                            <i className="fa fa-circle"></i>
                            <span className={styles.text}>
                              {t(childrenItem.title)}
                            </span>
                          </Link>
                        ) : null}
                        {childrenItem.children ? (
                          <ul
                            className={`sidebar-submenu ${
                              childrenItem.active ? "menu-open" : "active"
                            }`}
                          >
                            {childrenItem.children.map(
                              (childrenSubItem, key) => (
                                <li
                                  className={
                                    childrenSubItem.active ? "active" : ""
                                  }
                                  key={key}
                                >
                                  {childrenSubItem.type === "link" ? (
                                    <Link
                                      to={`${childrenSubItem.path}`}
                                      className={
                                        childrenSubItem.active ? "active" : ""
                                      }
                                      onClick={() =>
                                        toggletNavActive(childrenSubItem)
                                      }
                                    >
                                      <i className="fa fa-circle"></i>
                                      <span className={styles.text}>
                                        {t(childrenSubItem.title)}
                                      </span>
                                    </Link>
                                  ) : null}
                                </li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;
